import { render, staticRenderFns } from "./MedOnboardForm.vue?vue&type=template&id=202e56a0&scoped=true&"
import script from "./MedOnboardForm.vue?vue&type=script&lang=js&"
export * from "./MedOnboardForm.vue?vue&type=script&lang=js&"
import style0 from "./MedOnboardForm.vue?vue&type=style&index=0&id=202e56a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202e56a0",
  null
  
)

export default component.exports